<template>
  <UMain>
    <NuxtLoadingIndicator :height="5" color="#8F00FF" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications />
  </UMain>
</template>
